import { Card, SampleSubheader } from "../../../../../../components";
import styles from "./layout-blocks.module.scss";

const items = [
  { icon: "static-analysis", title: "Static Analysis", note: "Classification" },
  {
    icon: "dynamic-analysis",
    title: "Dynamic Analysis",
    note: "Classification"
  },
  {
    icon: "cloud-intelligence",
    title: "Threat Intelligence",
    note: "Classification"
  },
  {
    icon: "auxiliary-analysis",
    title: "Auxiliary Analysis",
    note: "Classification"
  },
  { icon: "network", title: "Network Analysis", note: "x/y Malicious" },
  { icon: "integrations-a", title: "Integrations", note: "x/y Malicious" }
];

const SubHeader = () => (
  <SampleSubheader>
    <SampleSubheader.Group>
      {items.slice(0, 3).map(item => (
        <Card
          key={item.title}
          disabled
          icon={item.icon}
          title={item.title}
          subtitle={
            <div className={styles.subtitle}>
              <span className={styles.label}>{item.note}</span>
            </div>
          }
        />
      ))}
    </SampleSubheader.Group>
    <SampleSubheader.Divider />
    <SampleSubheader.Group>
      {items.slice(3, 6).map(item => (
        <Card
          key={item.title}
          disabled
          icon={item.icon}
          title={item.title}
          subtitle={
            <div className={styles.subtitle}>
              <span className={styles.label}>{item.note}</span>
            </div>
          }
        />
      ))}
    </SampleSubheader.Group>
  </SampleSubheader>
);

export default SubHeader;
